<template>
  <div id="features" class="mx-auto flex flex-col gap-12 py-16 max-w-7xl px-4 sm:px-6 lg:px-8">
    <div class="flex flex-col gap-y-8 mx-auto w-full">
      <div class="flex flex-col w-full mx-auto justify-center items-center max-w-[800px] text-center">
        <h1 class="text-pretty text-3xl font-medium tracking-tight text-gray-900 sm:text-4xl lg:text-balance">
          Unleash creativity with powerful features
        </h1>
        <p class="mt-4 text-lg sm:text-xl sm:leading-[30px] text-gray-700 text-pretty sm:mt-2">
          Creating stunning postcards should be a joy, not a headache.
          We understand the importance of simplicity when it comes to
          design tools.
        </p>
      </div>

      <div class="flex items-center justify-center w-full">
        <Tabs
          default-value="tools"
          class="flex flex-col gap-y-10 w-full"
        >
          <TabsList class="w-full overflow-auto sm:w-auto sm:mx-auto">
            <TabsTrigger
              v-for="(tab, index) in tabs"
              :key="index"
              :value="tab.value"
            >
              {{ tab.label }}
            </TabsTrigger>
          </TabsList>
          <TabsContent
            v-for="(tab, index) in tabs"
            :key="index"
            :value="tab.value"
            class="w-full lg:min-w-[592px]"
          >
            <component
              :is="tab.component"
              class="w-full"
            />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { shallowRef } from "vue";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/Components/ui/tabs";
import ToolsTab from "./TabbedBentoTabs/ToolsTab.vue";
import VariableDataTab from "./TabbedBentoTabs/VariableDataTab.vue";
import PowerfulAddOnsTab from "./TabbedBentoTabs/PowerfulAddOnsTab.vue";

const tabs = shallowRef([
  {
    label: "Easy to use tools",
    value: "tools",
    component: ToolsTab
  },
  {
    label: "Variable Data & Preview",
    value: "data",
    component: VariableDataTab

  },
  {
    label: "Powerful add-ons",
    value: "addOns",
    component:
      PowerfulAddOnsTab
  },
  
]);
</script>
